import { useEffect, useState } from "react";
import { toast } from "sonner";
import { TreeStructure, Camera } from "@phosphor-icons/react";
import API from "../lib/api";
import { Switch } from "./ui/switch";

export default function SubJobsSettingsSection() {
  const [photosOptional, setPhotosOptional] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    API.get("/settings/sub-jobs").then(r => setPhotosOptional(!!r.data?.photos_optional)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggle = async (next) => {
    setSaving(true);
    try {
      await API.put("/settings/sub-jobs", { photos_optional: next });
      setPhotosOptional(next);
      toast.success(next ? "Operatives can now close sub-jobs without Before/After photos" : "Before/After photos are required again on sub-jobs");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5 max-w-2xl" data-testid="sub-jobs-settings">
      <h3 className="font-semibold flex items-center gap-2"><TreeStructure size={18} className="text-primary" /> Sub-jobs</h3>
      <p className="text-xs text-muted-foreground mt-1">A main job can be split into sub-jobs (JOB-XXXX-1, -2…) — one per item of work at the property. These options apply to every sub-job in your workspace.</p>
      <div className="mt-5 flex items-start justify-between gap-4 rounded-md border border-border p-4">
        <div className="flex items-start gap-3">
          <Camera size={20} className="text-muted-foreground mt-0.5 shrink-0" />
          <div>
            <p className="text-sm font-medium">Allow closing without Before/After photos</p>
            <p className="text-xs text-muted-foreground mt-1">
              By default an operative must upload at least one Before and one After photo before marking a job complete. Turn this on to let them close
              <strong> sub-jobs</strong> without photos — handy when clearing a snag list quickly. Main jobs and standalone jobs still require photos.
            </p>
            <p className="text-[11px] mt-2 font-medium" data-testid="sub-jobs-photos-state">
              {loading ? "Loading…" : photosOptional ? <span className="text-amber-600 dark:text-amber-400">Photos optional on sub-jobs</span> : <span className="text-emerald-600 dark:text-emerald-400">Photos required (default)</span>}
            </p>
          </div>
        </div>
        <Switch checked={photosOptional} disabled={loading || saving} onCheckedChange={toggle} data-testid="sub-jobs-photos-optional-switch" />
      </div>
    </div>
  );
}
